import React from "react";

const reasons = [
  {
    title: "Doświadczenie z realnego rynku",
    desc: "Działałem w firmach, które budowały floty od zera i takich, które wychodziły z zadłużenia. Wiem co działa i co tylko wygląda dobrze na papierze.",
  },
  {
    title: "Brak teorii — tylko praktyka",
    desc: 'Nie sprzedaję „modnych frameworków". Dostajesz konkretne rozwiązania, które ja sam wdrażałem i które przyniosły wyniki.',
  },
  {
    title: "Szybkie decyzje i konkretne działania",
    desc: "Nie będziemy miesiącami analizować. Patrzymy, ustalamy priorytety i działamy — bo kryzys i chaos nie lubią zwlekania.",
  },
  {
    title: 'Podejście partnerskie, nie „doradcze gadanie"',
    desc: "Nie jestem konsultantem w garniturze z PowerPointem. Jestem partnerem, który siada obok Ciebie i rozwiązuje problem razem z Tobą.",
  },
];

export default function WhyMe() {
  return (
    <section id="dlaczego-ja" data-testid="whyme-section" className="section relative overflow-hidden">
      <div className="absolute inset-0 -z-10 bg-gradient-to-b from-[#0a0a0a] via-[#0e0d0a] to-[#0a0a0a]" />
      <div className="hero-glow top-[20%] left-[-15%]" />

      <div className="container-x relative z-10">
        <div className="mt-0 grid grid-cols-1 md:grid-cols-2 gap-6">
          {reasons.map((r, idx) => (
            <div
              key={r.title}
              data-testid={`reason-${idx}`}
              className="card-dark p-9 lg:p-12 relative"
            >
              <div className="font-display text-[64px] leading-none text-[var(--gold)] opacity-25 absolute top-8 right-8">
                0{idx + 1}
              </div>
              <h3 className="font-display text-[22px] md:text-[26px] text-[#f5f1e8] relative z-10 pr-20">
                {r.title}
              </h3>
              <div className="gold-line mt-5 w-12" />
              <p className="mt-6 text-[15px] leading-[1.8] text-[#b8b3a7] relative z-10">
                {r.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
